module.exports = __webpack_public_path__ + "static/media/p5_img1.27610134.png";